import { sendGTMEvent } from '@next/third-parties/google'
import type { GtmGlobalStoreProps } from '../../useGTM'

export type GtmLanguageChangedType = {
  previous_user_language: string
  new_language: string | null
}

export const gtmLanguageChanged = ({
  new_language,
  globalStore,
}: GtmLanguageChangedType & GtmGlobalStoreProps) => {
  const { app } = globalStore
  const uuid = crypto.randomUUID()

  const isLanguageChanged = app.language !== new_language
  const previousLanguage = app.language

  sendGTMEvent({
    event: 'sho_user_language_changed',
    event_id: uuid,
    previous_user_language: app.language,
    user_language: isLanguageChanged ? new_language : previousLanguage,
  })
}
